module.exports = __webpack_public_path__ + "img/subject_banner3.262f29ca.png";